import {
  Exchange,
  ExchangeMarketHoursEntry,
  ExchangeScheduleResponse,
  ExchangeUpdateInput,
} from "../types/exchange";
import httpService from "./httpService";

class ExchangesService {
  private readonly baseUrl = "/v3/exchanges";
  private readonly adminBaseUrl = "/v3/admin/exchanges";

  async listExchanges(): Promise<Exchange[]> {
    const response = await httpService.get<{ exchanges: Exchange[] }>(this.baseUrl);
    return response.data.exchanges;
  }

  async getMarketHours(days: number = 7): Promise<ExchangeMarketHoursEntry[]> {
    const response = await httpService.get<{
      exchanges: ExchangeMarketHoursEntry[];
      requestTimeUtc: string;
    }>(`${this.baseUrl}/market-hours?days=${days}`);
    return response.data.exchanges;
  }

  async getByIbkrCode(ibkrCode: string): Promise<Exchange> {
    const response = await httpService.get<{ exchange: Exchange }>(
      `${this.baseUrl}/by-ibkr-code/${encodeURIComponent(ibkrCode)}`
    );
    return response.data.exchange;
  }

  async getSchedule(exchangeId: number, from?: string, to?: string): Promise<ExchangeScheduleResponse> {
    const params = new URLSearchParams();
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const qs = params.toString();
    const response = await httpService.get<ExchangeScheduleResponse>(
      `${this.baseUrl}/${exchangeId}/schedule${qs ? `?${qs}` : ""}`
    );
    return response.data;
  }

  async updateExchange(
    id: number,
    input: ExchangeUpdateInput
  ): Promise<Exchange> {
    const response = await httpService.patch<{
      success: boolean;
      exchange: Exchange;
    }>(`${this.adminBaseUrl}/${id}`, input);
    return response.data.exchange;
  }
}

export const exchangesService = new ExchangesService();
export default exchangesService;
